import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { NewCategory, UpdateCategoryRequest } from '@ilteducation/content-ref-data-types';
import DropFile from '@/components/base/DropFile.vue';
import ResourceImage from '@/components/base/ResourceImage.vue';
import DisableableButton from '@/components/buttons/DisableableButton.vue';
import useUploadMedia from '@/comp/use-upload-media';
import store from '@/store';

type Props = {
  item: NewCategory;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryImageUploader',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: NewCategory;
}

const { upload, uploadInProgress } = useUploadMedia();



const file = ref(null);
const isChanged = ref(false);
const isLoading = ref(false);

const defaultUpload = async () => {
  isLoading.value = true;

  try {
    const response = await store.dispatch('content-image/create', {
      data: { description: `category: ${props.item.id}`, type: 'ImageV1', realm: 'all' },
    });

    const createdImageId = response.data.id;

    await upload(response.data.id, file.value[0]);

    const categoryUpdateRequest: UpdateCategoryRequest = {
      ...props.item,
      imageId: createdImageId,
    };

    // For some reason the category has createdAt and lastUpdatedAt fields that would invalidate the request
    delete categoryUpdateRequest.createdAt;
    delete categoryUpdateRequest.lastUpdatedAt;

    await store.dispatch('categories/update', {
      id: props.item.id,
      data: categoryUpdateRequest,
    });
  } finally {
    isLoading.value = false;
  }
};

const changeHandler = (inputFile: any) => {
  if (!inputFile || !inputFile.length) {
    isChanged.value = false;
    return;
  }

  isChanged.value = true;
  file.value = inputFile;
};

return { __sfc: true,upload, uploadInProgress, props, file, isChanged, isLoading, defaultUpload, changeHandler, DropFile, ResourceImage, DisableableButton }
}

})